import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { CurrentUser } from '../axios/currentUser';

export function strongifyWord(string: string, word: string) {
  return string.replace(word, `<strong>${word}</strong>`);
}

export function stringToColor(string: string) {
  if (!string) return;
  const hash = Array.from(string).reduce(
    (hash, char) => char.charCodeAt(0) + ((hash << 5) - hash),
    0,
  );

  const color = Array.from({ length: 3 }, (_, i) => {
    const value = (hash >> (i * 8)) & 0xff;
    return `00${value.toString(16)}`.slice(-2);
  }).join('');

  return `#${color}`;
}

export function sortByKey<T>(array: T[], key: keyof T, ascending = true): T[] {
  return [...array].sort((a, b) => {
    let comparison = 0;

    if (a[key] < b[key]) {
      comparison = -1;
    } else if (a[key] > b[key]) {
      comparison = 1;
    }

    return ascending ? comparison : comparison * -1;
  });
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isSupportOrAdmin(currentUser: CurrentUser) {
  return currentUser?.is_support || currentUser?.is_superadmin;
}
